import React from "react";
import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Button,
    Card,
    CardActions,
    CardContent,
    Chip,
    Divider,
    Stack,
    Typography,
} from "@mui/material";
import Grid2 from "@mui/material/Grid2";
import ExpandMoreRoundedIcon from "@mui/icons-material/ExpandMoreRounded";

import { fmtMoney, toNum } from "./articleUtils";

export default function ArticleGroupList({ groups, resolveIndex, onEdit, onDeleteAsk }) {
    return (
        <Stack spacing={2}>
            {groups.map((group) => (
                <Accordion key={group.key} defaultExpanded>
                    <AccordionSummary expandIcon={<ExpandMoreRoundedIcon />}>
                        <Stack direction="row" spacing={1} alignItems="center">
                            <Typography variant="subtitle1" sx={{ fontWeight: 800 }}>
                                {group.key}
                            </Typography>
                            <Chip size="small" label={group.artikels.length} />
                        </Stack>
                    </AccordionSummary>
                    <AccordionDetails>
                        <Grid2 container spacing={2}>
                            {group.artikels.map((artikel) => {
                                const originalIndex = resolveIndex(artikel);
                                const net = toNum(artikel.price);
                                const rate = toNum(artikel.taxRate);
                                const gross = net * (1 + rate / 100);
                                return (
                                    <Grid2 key={artikel.id} xs={12} sm={6} md={4} lg={3}>
                                        <Card
                                            variant="outlined"
                                            sx={{
                                                borderRadius: 3,
                                                height: "100%",
                                                boxShadow: "0 8px 28px rgba(0,0,0,0.06)",
                                                transition: "transform .12s ease, box-shadow .12s ease",
                                                "&:hover": { transform: "translateY(-2px)", boxShadow: 6 },
                                            }}
                                        >
                                            <CardContent>
                                                <Stack direction="row" justifyContent="space-between" alignItems="flex-start">
                                                    <Typography variant="subtitle1" fontWeight={700} noWrap title={artikel.name}>
                                                        {artikel.name || "—"}
                                                    </Typography>
                                                    <Chip size="small" label={`${rate}%`} variant="outlined" />
                                                </Stack>

                                                <Typography variant="caption" color="text.secondary">
                                                    #{artikel.articleNumber || "—"}
                                                </Typography>

                                                {artikel.description && (
                                                    <Typography
                                                        variant="body2"
                                                        color="text.secondary"
                                                        sx={{ mt: 0.5 }}
                                                        noWrap
                                                        title={artikel.description}
                                                    >
                                                        {artikel.description}
                                                    </Typography>
                                                )}

                                                <Divider sx={{ my: 1.25 }} />

                                                <Stack spacing={0.5}>
                                                    <Typography variant="body2">
                                                        <strong>Netto:</strong> {fmtMoney(net, artikel.currency || "EUR")}
                                                    </Typography>
                                                    <Typography variant="body2">
                                                        <strong>Brutto:</strong> {fmtMoney(gross, artikel.currency || "EUR")}
                                                    </Typography>

                                                    <Stack direction="row" spacing={1} sx={{ mt: 0.5 }} flexWrap="wrap">
                                                        {artikel.unit && <Chip label={`Einheit: ${artikel.unit}`} size="small" />}
                                                        {artikel.currency && (
                                                            <Chip
                                                                label={`Währung: ${artikel.currency}`}
                                                                size="small"
                                                                variant="outlined"
                                                            />
                                                        )}
                                                        {artikel.hasAmount && (
                                                            <Chip
                                                                label={`Bestand: ${artikel.amount ?? 0}`}
                                                                size="small"
                                                                color="info"
                                                                variant="outlined"
                                                            />
                                                        )}
                                                    </Stack>
                                                </Stack>
                                            </CardContent>

                                            <CardActions sx={{ pt: 0, pb: 2, px: 2 }}>
                                                <Button size="small" onClick={() => onEdit(originalIndex)}>
                                                    Bearbeiten
                                                </Button>
                                                <Button size="small" color="error" onClick={() => onDeleteAsk(artikel, originalIndex)}>
                                                    Löschen
                                                </Button>
                                            </CardActions>
                                        </Card>
                                    </Grid2>
                                );
                            })}
                        </Grid2>
                    </AccordionDetails>
                </Accordion>
            ))}
        </Stack>
    );
}
